import { render, staticRenderFns } from "./BomTree.vue?vue&type=template&id=d4b531ca&scoped=true&"
import script from "./BomTree.vue?vue&type=script&lang=js&"
export * from "./BomTree.vue?vue&type=script&lang=js&"
import style0 from "./BomTree.vue?vue&type=style&index=0&id=d4b531ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b531ca",
  null
  
)

export default component.exports